import * as React from 'react';
const FeatureServiceContext = React.createContext({
    trackingService: {},
    contentService: {},
    logger: console,
});
export default FeatureServiceContext;
